<template>
    <div class="footer-content">
        <div class="content">
            <div class="item" v-for="item in list" :key="item.id">
                <div class="title">
                    {{ item.title }}
                </div>
                <div class="text">
                    {{ item.text }}
                </div>
            </div>
            <div class="item">
                <div class="title">
                    ความช่วยเหลือ
                </div>
                <div class="text" @click="handleClick('/service')">การสนับสนุนและฐานความรู้</div>
                <div class="text" @click="handleClick('/about')">ขอสาธิต</div>
                <div class="text" @click="handleClick('/contact')">ติดต่อเรา</div>
            </div>
        </div>
        <div class="bottom">
            © 2025 สงวนลิขสิทธิ์ AI-XENIX COMPANY LIMITED
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const handleClick = (path) => {
    router.push(path);
    window.scrollTo(0, 0);
};
const list = [
    {
        id: 1,
        title: "บริษัทที่ให้บริการ:",
        text: "AI-XENIX COMPANY LIMITED",
    },
    {
        id: 2,
        title: "สายด่วนบริการ:",
        text: "+66 0816579949",
    },
    {
        id: 3,
        title: "อีเมลบริการ:",
        text: "company@ai-xenix.com",
    },
    {
        id: 4,
        title: "ที่อยู่บริการ:",
        text: "19/60 หมู่บ้านนันทวัน รามอินทรา-วัชรพล ถนนสุขาภิบาล 5 แขวงออเงิน เขตสายไหม กรุงเทพมหานคร",
    },
];
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 161px;
    background-color: #333333;
    box-sizing: border-box;

    .content {
        padding: 33px 270px 25px;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;

        .item {
            max-width: 128px;
            font-weight: bold;
            font-size: 11px;
            color: #FFFFFF;
            line-height: 15px;

            .title {
                margin-bottom: 8px;
            }

            .text {
                cursor: pointer;
            }
        }
    }

    .bottom {
        height: 37px;
        background: #2A2A2A;
        border: 1px solid rgba(169, 169, 169, 0.29);
        font-weight: 500;
        font-size: 10px;
        color: #D7D7D7;
        line-height: 37px;
        text-align: center;
    }
}
</style>